module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/pOhjXM/tc-custom/9781960332073.jpg?1733084686512",
      "alt": "This image is the cover for the book Dances with Donkeys"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Dances with Donkeys\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Journey through the dusty plains of Texas and the rugged mountains of Colorado in author Jim Duke’s debut, DANCES WITH DONKEYS: The Memoir of a Half-Assed Cowboy—the often hilarious, occasionally poignant, sometimes hair-raising, and always entertaining tales of a man who dropped out of high school and took off for Texas to become a cowboy.   In this captivating memoir, Duke recounts his adventures and ass-inine misadventures with mules, donkeys and horses as he introduces readers to the complexity and variety of personalities among these intelligent creatures. Through prose and poetry, he shows the deep bond that can form between humans and equines.     Whether you're a fan of cowboy culture or just love a good memoir, DANCES WITH DONKEYS is reminiscent of cowboy poet laureate Baxter Black with a twist in the saddle. You'll laugh your \"ass\" off and come away with a whole new understanding of why little boys (and girls) grow up dreaming of being cowboys. Don't miss out on this one-of-a-kind journey into the heart of the American West.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Jim Duke\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    WildBlue Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0